import { render } from "./GoogleFormList.vue?vue&type=template&id=1b23776c&scoped=true"
import script from "./GoogleFormList.vue?vue&type=script&lang=js"
export * from "./GoogleFormList.vue?vue&type=script&lang=js"

import "./GoogleFormList.vue?vue&type=style&index=0&id=1b23776c&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b23776c"]])

export default __exports__